<script setup>
import { RouterView, useRoute } from "vue-router";
import { auth } from "./plugins/keycloak";
import { sessionFormat } from "./filters";
const route = useRoute();
import RegistrationSearch from "./components/RegistrationSearch.vue";
</script>

<template>
    <q-layout view="hHh lpR fFf">
        <q-header elevated class="bg-primary text-white">
            <q-toolbar>
                <router-link to="/"><img id="logo" src="./assets/unil-logo-white.svg" /></router-link>
                <q-toolbar-title class="text-center">
                    Prise de rendez-vous pour consultation d'examens
                </q-toolbar-title>
                <q-btn
                    v-if="auth.isAuthenticated.value"
                    flat
                    no-caps
                    class="print-hide"
                    :label="$q.screen.gt.xs ? auth.fullName.value : ''"
                    icon="fa-solid fa-user"
                    :icon-right="$q.screen.gt.xs ? 'fa-solid fa-caret-down' : ''"
                >
                    <q-menu fit anchor="bottom left" self="top left">
                        <q-list style="min-width: 100px">
                            <q-item v-if="auth.isStaff.value" v-close-popup clickable to="/admin">
                                <q-item-section avatar>
                                    <q-icon name="fa-solid fa-clipboard-user" />
                                </q-item-section>
                                <q-item-section>Administration</q-item-section>
                            </q-item>
                            <q-item v-close-popup clickable>
                                <q-item-section avatar>
                                    <q-icon name="fa-solid fa-right-from-bracket" />
                                </q-item-section>
                                <q-item-section @click="auth.logout()">Se déconnecter</q-item-section>
                            </q-item>
                        </q-list>
                    </q-menu>
                </q-btn>
            </q-toolbar>
            <q-toolbar v-if="route.name?.includes('admin')" inset class="print-hide">
                <q-breadcrumbs active-color="white">
                    <q-breadcrumbs-el label="Home" icon="fa-solid fa-house" to="/admin" />
                    <q-breadcrumbs-el
                        v-if="route.params.sessionCode"
                        :label="sessionFormat(route.params.sessionCode)"
                        :to="`/admin/session/${route.params.sessionCode}`"
                    />
                    <q-breadcrumbs-el v-if="route.name === 'admin-session-slots'" label="Créneaux" />
                    <q-breadcrumbs-el v-if="route.name === 'admin-session-mutations'" label="Mutations" />
                </q-breadcrumbs>
                <q-space />
                <registration-search v-if="route.name === 'admin-session'" />
            </q-toolbar>
        </q-header>

        <q-page-container>
            <router-view />
        </q-page-container>
    </q-layout>
</template>

<style>
body {
    background-color: #f6f7ff;
    color: #222;
}
@media print {
    body {
        background-color: transparent;
    }
}

#app {
    max-width: 1280px;
    margin: 0 auto;
}

#logo {
    height: 60px;
    padding: 6px 6px;
    vertical-align: middle;
}
.nav-button {
    min-width: 200px;
}
.white-space-normal {
    white-space: normal !important;
}
</style>
